import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import JobTypeForm from './JobTypeForm';

// Rename the name of the function:
const JobTypeList: React.FC = () => {

    // Group by division name when viewing the whole environment
    const { activeFeatures } = useAuthContext();
    const { divisions, selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const mainDivision = divisions.find(division => division.is_main);
    const groupByField = activeFeatures.includes('divisions') && isEnvironmentSelected ? {
        field: 'division',
        formatValue: (divisionId: string) => divisions.find(division => String(division.id) === divisionId)?.name || mainDivision?.name || divisionId,
    } : undefined;

    // Filter the list on the division selected in the settings menu
    const divisionParams = !isEnvironmentSelected && selectedDivision ? { 'division_scope': selectedDivision.id } : {};

    // Specify the options of this list:
    const query = {
        endpoint: 'get_workflow_for_feature_list/job',
        defaultParams: { 'is_active': true, ...divisionParams },
        object: 'workflow'
    }
    const objectName = 'job.job_type.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deactivated'
    const isDraggable = true
    const draggingApiUrl = 'patch_workflow_ordering/job'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <JobTypeForm />;
    const modalSize = 'medium'
    const onRowClick = 'editModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'job.job_type.general.name_label' },
    ];

    return (
        <AbstractList
            key={!isEnvironmentSelected && selectedDivision ? selectedDivision.id : 'environment'}
            query={query}
            objectName={objectName}
            columns={columns}
            groupByField={groupByField}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            modalSize={modalSize}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            isDraggable={isDraggable}
            draggingApiUrl={draggingApiUrl}
        />
    );
};

export default JobTypeList;